import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  pseudo : string | undefined;
  nom : string | undefined;
  adresse : string | undefined;
  avatar : string | undefined;
  
  constructor(
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getProfile();
  }
  
  getProfile(): void {
    let profile = Number(this.route.snapshot.paramMap.get('id'));
    if (profile==1){
      this.pseudo = "jkaryo"
      this.nom="Julien Karyo"
      this.adresse="0x......."
      this.avatar="assets/img/avatars/jkaryo.jpeg"
    }
    else{
      this.pseudo="csurbier"
      this.nom="Christophe Surbier"
      this.adresse="0x......."
      this.avatar="assets/img/avatars/csurbier.jpeg"
    }
    
  }

}
